<template>
  <div>
    <v-stepper v-model="e1" v-if="content">
      <v-stepper-header>
        <template v-for="(label, index) in stepLabels">
          <v-stepper-step :key="`step-${index}`" color="amber" :complete="e1 > index + 1" :step="index + 1"
            @click="goToStep(index + 1)">{{ label }}</v-stepper-step>
          <v-divider :key="`divider-${index}`"></v-divider>
        </template>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-row>
            <v-col cols="5">
              <h1 v-text="step1.title"></h1>
              <p v-for="(item, index) in step1.description" :key="index" v-html="item" />

            </v-col>
            <v-col cols="6" offset="1">
              <v-form v-model="valid" ref="detailsForm">
                <v-row>
                  <v-col cols="12">
                    <p v-if="step1.formTitle" v-text="step1.formTitle"></p>
                    <template v-for="field in fields">
                      <div :key="field.key">
                        <p v-if="field.heading" v-text="field.heading"></p>
                        <v-select v-if="field.type === 'select'" :items="field.options" :label="field.label"
                          v-model.trim="details[field.key]" :rules="field.rules" item-text="title" item-value="title"
                          color="amber" :required="field.required" @change="onSelectChange(field)"></v-select>
                        <v-textarea v-else-if="field.type === 'textarea'" :label="field.label"
                          v-model.trim="details[field.key]" :rules="field.rules" rows="3" color="amber"
                          :required="field.required"></v-textarea>
                        <v-radio-group v-else-if="field.type === 'radio'" v-model="details[field.key]"
                          :rules="field.rules" :label="field.label" @change="onSelectChange(field)" column>
                          <v-radio v-for="option in field.options" :key="option.title" :label="option.title"
                            :value="option.title" color="amber"></v-radio>
                        </v-radio-group>
                        <template v-else-if="field.type === 'checkbox'">
                          <!-- with options: a group of checkboxes stored as an array -->
                          <v-checkbox v-for="(option, i) in field.options" :key="option.title"
                            v-model="details[field.key]" :label="option.title" :value="option.title" color="amber"
                            hide-details="auto" :rules="i === field.options.length - 1 ? field.rules : field.noRules"
                            @change="onSelectChange(field)"></v-checkbox>
                          <!-- without options: a single true / false checkbox -->
                          <v-checkbox v-if="!field.options.length" v-model="details[field.key]" :label="field.label"
                            :rules="field.rules" color="amber"></v-checkbox>
                        </template>
                        <v-text-field v-else :label="field.label" v-model.trim="details[field.key]" :rules="field.rules"
                          color="amber" :required="field.required"></v-text-field>
                        <v-text-field v-if="showOther(field)" :label="field.otherLabel"
                          v-model.trim="details[field.otherKey]" :rules="field.otherRules" color="amber"
                          required></v-text-field>
                      </div>
                    </template>
                  </v-col>
                  <v-col cols="12">
                    <v-btn class="amber" light :disabled="!valid" @click="nextStep" v-text="nextLabel"></v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-col>
          </v-row>
          <bottom-navigation :save="false" :next="valid" :prev="false" :gridView="false" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep">
          </bottom-navigation>
        </v-stepper-content>
        <v-stepper-content step="2">
          <v-row>
            <v-col cols="6" class="mb-12">
              <h2 v-text="step2.title"></h2>
              <p v-for="(item, index) in step2.description" :key="index" v-html="item" />
            </v-col>
          </v-row>

          <v-row dense v-if="gridView && words.length >= 1" class="mb-10">
            <!-- <v-col v-for="card in words" :key="card.id" :cols="2"> -->
            <div v-for="card in words" :key="card.id" :style="{ width: computedZoom }">
              <v-card class="mx-auto card" :data-id="card.id"
                :class="{ selected: card.selected, smaller: computedZoomClass }" @click="selectCard(card.id)"
                :hover="true" :elevation="1">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <div class="card__inner" :style="{ backgroundImage: `url(${card.src})` }" v-if="card.type == 'Image'">
                </div>
                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </div>
            <!-- </v-col> -->
          </v-row>

          <v-carousel height="60vh" cycle hide-delimiters v-else-if="words && words.length >= 1"
            class="align-center mb-10">
            <v-carousel-item v-for="card in words" :key="card.id">
              <v-card class="mx-auto mb-2 card" :data-id="card.id" :class="{ selected: card.selected }"
                @click="selectCard(card.id)" :elevation="10" :hover="true">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <div class="card__inner" :style="{ backgroundImage: `url(${card.src})` }" v-if="card.type == 'Image'">
                </div>
                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </v-carousel-item>
          </v-carousel>

          <bottom-navigation :save="false" :next="true" :prev="true" :gridView="true" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep" v-model="zoom">
            <p class="no-margin">
              {{ step2.selectedLabel || 'Selected words' }}
              <v-chip :class="wordsCheck" class="white--text">{{
                selectedWords.length
              }}</v-chip>
            </p>
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-row class="mb-12">
            <v-col cols="6">
              <h2 v-text="step3.title"></h2>
              <p v-for="(item, index) in step3.description" :key="index" v-html="item" />
              <p v-text="step3.selectedWordsLabel || 'Your selected words:'"></p>
              <v-chip v-for="word in selectedWords" :key="word.title" class="white black--text mx-1">{{ word.title
              }}</v-chip>
            </v-col>
            <v-col cols="6">
              <p v-text="step3.filterLabel || 'Filter'"></p>
              <v-select :items="filterOptions" v-model="filters" @change="changeFilter"></v-select>
            </v-col>
          </v-row>

          <v-row dense v-if="gridView" class="mb-10">
            <!-- <v-col v-for="card in images" :key="card.id" :cols="2"> -->
            <div v-for="card in images" :key="card.id" :style="{ width: computedZoom }">
              <v-card class="mx-auto card" :data-id="card.id" :class="{ selected: card.selected }"
                @click="selectCard(card.id)">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <div class="card__inner" v-if="card.type == 'Image'">
                  <Imgx :src="card.src" />
                </div>

                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </div>
            <!-- </v-col> -->
          </v-row>

          <v-carousel height="60vh" cycle hide-delimiters v-else class="align-center">
            <v-carousel-item v-for="card in images" :key="card.id" class="mb-10">
              <v-card class="mx-auto mb-2 card" :data-id="card.id" :class="{ selected: card.selected }"
                @click="selectCard(card.id)" :elevation="10">
                <div class="card__inner" v-if="card.type == 'Word'">
                  <div class="card__inner__text">
                    <h2>{{ card.title }}</h2>
                  </div>
                </div>
                <!-- <div
									class="card__inner"
									:style="{ backgroundImage: `url(${card.src})` }"
									v-if="card.type == 'Image'"
								></div> -->
                <div class="card__inner" v-if="card.type == 'Image'">
                  <Imgx :src="card.src" />
                  <!-- <ix-img class="imgix" :src="card.src" sizes="30vw" /> -->
                </div>
                <v-icon class="chk" v-if="card.selected">mdi-check</v-icon>
              </v-card>
            </v-carousel-item>
          </v-carousel>

          <bottom-navigation :save="false" :next="true" :prev="true" :gridView="true" :gridToggle="false"
            @save="saveExercise" @prev="prevStep" @next="nextStep" v-model="zoom">
            <p class="no-margin">
              {{ step3.selectedLabel || 'Selected images' }}
              <v-chip :class="imagesCheck" class="white--text">{{
                selectedImages.length
              }}</v-chip>
            </p>
          </bottom-navigation>
        </v-stepper-content>

        <v-stepper-content step="4" class="">
          <v-row dense>
            <v-col cols="6">
              <h2 v-text="step4.title"></h2>
              <p v-for="(item, index) in step4.description" :key="index" v-html="item" />
            </v-col>
          </v-row>

          <TilesGridArranger v-if="shortlist && shortlist.length" :tiles="shortlist" v-model="gridSlots"
            :initial-cell-size="gridCellSize" :initial-cols="gridCols" @update-cell-config="onUpdateCellConfig" />

          <bottom-navigation :save="true" save-label="SAVE" :next="false" :prev="true" :gridView="false"
            :gridToggle="false" @save="saveExercise" @prev="prevStep" @next="nextStep" v-model="cols">
          </bottom-navigation>
        </v-stepper-content>


      </v-stepper-items>
    </v-stepper>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline" v-text="saved.title || 'Exercise saved'"></v-card-title>

        <v-card-text v-text="saved.description || 'Thank you for your participation'"></v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="dialog = false">
            {{ saved.closeLabel || 'Close' }}
          </v-btn>

          <v-btn color="amber accent-1" text to="/users/dashboard">
            {{ saved.dashboardLabel || 'Back to Dashboard' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import lodash from "lodash";
import { store } from "@/store";
// import draggable from "vuedraggable";
import { BottomNavigation, Imgx } from "@/components/core";
import { stepFields } from "@/utils/surveyFields";
import TilesGridArranger from "@/views/user/exercises/tiles/TilesGridArranger";

const fb = require("@/firebaseConfig.js");

export default {
  name: "BrandTiles",
  data() {
    return {
      exercise: {},
      content: null,
      // answers for the step 1 form, keyed by the field keys defined in the content file
      details: {},
      dragging: false,
      list: null,
      shortlist: [],
      gridSlots: [],
      gridCols: 4,
      gridCellSize: 120,
      valid: false,
      e1: 1,
      gridView: true,
      cols: 4,
      zoom: 7,
      rows: 4,
      filters: "All",
      dialog: false,
      dropdownCategories: [
        "All",
        "Selected",
        "Colour",
        "Illustration",
        "Pattern",
        "Photography",
        "Typography",
      ],
      // 🔑 Anonymous user id, stored in a cookie
      userId: null,
      tilesUnsub: null,
      exerciseUnsub: null,
    };
  },
  components: {
    BottomNavigation,
    Imgx,
    TilesGridArranger
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "tiles", "currentProjectModel"]),

    // --- CONTENT (public/content/{projectId}.json) ---
    survey() {
      if (!this.content) return {};
      const key = this.$route.meta.content || "exercise_tiles_survey";
      return this.content[key] || this.content.exercise_tiles_survey || {};
    },
    step1() {
      return this.survey.step1 || {};
    },
    step2() {
      return this.survey.step2 || {};
    },
    step3() {
      return this.survey.step3 || {};
    },
    step4() {
      return this.survey.step4 || {};
    },
    stepLabels() {
      if (Array.isArray(this.survey.steps) && this.survey.steps.length) {
        return this.survey.steps;
      }
      return [
        this.step1.label || this.step1.tab || "Details",
        this.step2.label || this.step2.tab || "Choose 4 Words",
        this.step3.label || this.step3.tab || "Choose 16 Images",
        this.step4.label || this.step4.tab || "Arrange",
      ];
    },
    nextLabel() {
      return this.step1.nextLabel || "Next step";
    },
    saved() {
      return this.survey.saved || {};
    },
    filterOptions() {
      const filters = this.step3.filters;
      return Array.isArray(filters) && filters.length
        ? filters
        : this.dropdownCategories;
    },

    // --- STEP 1 FORM FIELDS ---
    // Declared in the content file as step1.fields, see @/utils/surveyFields
    fields() {
      return stepFields(this.step1);
    },
    // answers written to firestore, flattened + nulled for empty values
    detailsPayload() {
      const payload = {};
      Object.keys(this.details).forEach((key) => {
        const value = this.details[key];
        payload[key] = value === undefined || value === "" ? null : value;
      });
      return payload;
    },
    computedWidh() {
      switch (this.cols) {
        case 1:
          return "100%";
        case 2:
          return "50%";
        case 3:
          return "33.33%";
        case 4:
          return "25%";
        case 5:
          return "20%";
        case 6:
          return "16.666666666666667%";
        case 7:
          return "14.285714285714286%";
        case 8:
          return "12.5%";
        case 9:
          return "11.111111111111111%";
        case 10:
          return "10%";
        default:
          return "25%";
      }
    },
    computedZoom() {
      switch (this.zoom) {
        case 10:
          return "100%";
        case 9:
          return "50%";
        case 8:
          return "33.33%";
        case 7:
          return "25%";
        case 6:
          return "20%";
        case 5:
          return "16.666666666666667%";
        case 4:
          return "14.285714285714286%";
        case 3:
          return "12.5%";
        case 2:
          return "11.111111111111111%";
        case 1:
          return "10%";
        default:
          return "25%";
      }
    },
    computedZoomClass() {
      switch (this.zoom) {
        case 10:
        case 9:
        case 8:
        case 7:
        case 6:
          return "";
        default:
          return "smaller";
      }
    },
    computedRows() {
      return Math.ceil(this.shortlist.length / this.cols);
    },
    computedCells() {
      return this.cols * this.computedRows;
    },
    wordsCheck() {
      return this.selectedWords.length > 4 ? "red" : "grey darken-2";
    },
    imagesCheck() {
      return this.selectedImages.length > 16 ? "red" : "grey darken-2";
    },
    words() {
      if (this.list && this.list.length) {
        let list = this.list.filter((item) => item.type == "Word");
        return lodash.orderBy(list, "title", "asc");
      } else {
        return [];
      }
    },
    images() {
      if (this.list) {
        let arr = this.list.filter((item) => item.type == "Image");
        if (this.filters == "All") {
          return lodash.orderBy(arr, "id", "asc");
        } else if (this.filters == "Selected") {
          let filtered = this.shortlist.filter((item) => item.type == "Image");
          return lodash.orderBy(filtered, "title", "desc");
        } else {
          const filteredArr = arr.filter(
            (item) => item.category === this.filters
          );
          return lodash.orderBy(filteredArr, "id", "desc");
        }
      } else {
        return [];
      }
    },
    selectedImages() {
      if (this.shortlist) {
        let filtered = this.shortlist.filter((item) => item.type == "Image");
        return lodash.orderBy(filtered, "title", "desc");
      } else {
        return [];
      }
    },
    selectedWords() {
      if (this.shortlist) {
        const list = this.shortlist.filter((item) => item.type == "Word");
        return list.length >= 1 ? list : [];
      } else {
        return [];
      }
    },
  },

  watch: {
    // content arrives after the exercise doc, so map stored answers onto the fields
    fields() {
      this.hydrateDetails();
      this.validateDetails();
    },
  },

  async created() {
    // GET request using fetch with async/await
    console.log("loading content");
    const response = await fetch(`/content/${this.$route.params.id}.json`);
    const data = await response.json();
    this.content = data;
  },

  mounted() {
    this.$nextTick(() => {
      // 🔑 Initialise / retrieve anonymous user id from cookie
      this.initUserId();
      this.loadTiles();
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.$nextTick(() => {
      if (!this.userId) {
        this.initUserId();
      }
      // tiles likely already in Vuex; just reload exercise
      this.getExercise();
    });
    next();
  },
  beforeDestroy() {
    if (this.tilesUnsub) {
      this.tilesUnsub();
      this.tilesUnsub = null;
    }
    if (this.exerciseUnsub) {
      this.exerciseUnsub();
      this.exerciseUnsub = null;
    }
  },

  methods: {
    // --- CONTENT DRIVEN FIELDS ---
    showOther(field) {
      if (!field.allowOther) return false;
      const value = this.details[field.key];
      return Array.isArray(value)
        ? value.indexOf(field.otherTitle) !== -1
        : value === field.otherTitle;
    },
    onSelectChange(field) {
      // drop a stale "other" answer when a listed option is picked instead
      if (field.allowOther && !this.showOther(field)) {
        this.$set(this.details, field.otherKey, "");
      }
    },
    validateDetails() {
      this.$nextTick(() => {
        if (this.$refs.detailsForm) {
          this.$refs.detailsForm.resetValidation();
          this.$refs.detailsForm.validate();
        }
      });
    },
    emptyValue(field) {
      if (field.type !== "checkbox") return "";
      return field.multiple ? [] : false;
    },
    isEmpty(value) {
      return value === undefined || value === null || value === "";
    },
    hydrateDetails() {
      const stored = Object.assign({}, (this.exercise && this.exercise.details) || {});
      this.fields.forEach((field) => {
        // the field value itself, plus the free text behind an "other" option
        const entries = [[field.key, this.emptyValue(field)]];
        if (field.allowOther) entries.push([field.otherKey, ""]);

        entries.forEach(([key, empty]) => {
          if (!this.isEmpty(stored[key])) return;
          // fall back to the legacy flat properties (firstName, region, ...)
          const legacy = this.exercise ? this.exercise[key] : null;
          stored[key] = this.isEmpty(legacy) ? empty : legacy;
        });
      });
      this.details = stored;
    },

    // --- STEP NAV ---
    goToStep(step) {
      // only allow jumping back to a step already reached
      if (step <= this.e1) {
        this.e1 = step;
      }
    },
    nextStep() {
      this.e1++;
      this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      this.saveExercise(false);
    },

    // --- DRAGGING ---
    startDrag() {
      this.dragging = true;
    },
    endDrag() {
      let count = 0;
      let vm = this;
      let div = document.getElementById("tiles");
      div.children.forEach((doc) => {
        let item = this.shortlist.find((x) => x.id === doc.dataset.id);
        let indexOfItem = this.shortlist.indexOf(item);
        item.index = count;
        vm.$set(vm.shortlist, indexOfItem, item);
        count++;
      });
      this.dragging = false;
    },
    onUpdateCellConfig({ cols, cellSize }) {
      this.gridCols = cols;
      this.gridCellSize = cellSize;
    },
    // --- SHORTLIST / LIST HELPERS ---
    createShortlist() {
      let l = this.list.filter((item) => item.selected == true);
      this.shortlist = lodash.orderBy(l, "index", "asc");
    },
    loadShortlist() {
      if (this.exercise) {
        this.shortlist = this.exercise.selectedTiles || [];
      } else {
        this.shortlist = this.list.filter((item) => item.selected == true);
      }
    },
    updateShortList(item) {
      if (item.selected == true) {
        item.index = this.shortlist.length;
        this.shortlist.push(item);
      } else {
        let ref = this.shortlist.find((x) => x.id === item.id);
        let indexOfItem = this.shortlist.indexOf(ref);
        if (indexOfItem !== -1) {
          this.shortlist.splice(indexOfItem, 1);
        }
      }
      this.saveExercise(false);
    },
    createList() {
      let list = this.tiles;
      let count = 0;
      list.forEach((item) => {
        item.selected = this.checkId(item.id);
        item.index = count;
        count++;
      });
      this.list = list;
      this.createShortlist();
    },

    // --- FIREBASE LOADING ---
    loadTiles() {
      // if we already have a tiles listener, don't add another
      if (!this.tilesUnsub && this.tiles.length === 0) {
        this.tilesUnsub = fb.tilesCollection
          .orderBy("createdOn", "desc")
          .onSnapshot((querySnapshot) => {
            const items = [];
            querySnapshot.forEach((doc) => {
              items.push(doc.data());
            });
            store.commit("setTiles", items);
            this.getExercise(); // tiles loaded -> now load exercise
          });
      } else {
        // tiles already in Vuex, just load exercise (but don't resub tiles)
        this.getExercise();
      }
    },
    checkId(id) {
      const selected = (this.exercise && this.exercise.selectedTiles) || [];
      return selected.filter((item) => item.id == id).length >= 1;
    },
    selectCard(id) {
      let vm = this;
      let item = this.list.find((item) => item.id === id);
      let indexOfItem = this.list.indexOf(item);
      let truthy = item.selected;
      item.selected = !truthy;
      vm.$set(vm.list, indexOfItem, item);
      this.updateShortList(item);
    },

    getExercise() {
      if (!this.userId) return;

      // 🔹 if a previous exercise listener exists, remove it
      if (this.exerciseUnsub) {
        this.exerciseUnsub();
        this.exerciseUnsub = null;
      }

      const ref = fb[this.$route.meta.model]
        .where("uid", "==", this.userId)
        .where(
          "pid",
          "==",
          this.currentProjectModel && this.currentProjectModel.id
            ? this.currentProjectModel.id
            : "unknown"
        );

      this.exerciseUnsub = ref.onSnapshot((querySnapshot) => {
        let doc = null;
        querySnapshot.forEach((d) => {
          doc = d.data();
        });

        const base = {
          id: null,
          details: {},
          selectedTiles: [],
          cols: this.cols,
          step: 1,
          gridSlots: [],
        };

        this.exercise = Object.assign({}, base, doc || {});
        this.hydrateDetails();

        this.shortlist = this.exercise.selectedTiles || [];
        this.cols = this.exercise.cols || this.cols;
        this.e1 = this.exercise.step || 1;

        // 🔹 hydrate arranger state
        this.gridSlots = this.exercise.gridSlots || [];
        this.gridCols = this.exercise.gridCols || 4;
        this.gridCellSize = this.exercise.cellSize || null;

        this.createList();
        this.loadShortlist();

        this.validateDetails();
      });
    },

    // --- SECURE RANDOM STRING + COOKIES ---
    secureRandomString(length = 16) {
      // cryptographically secure random hex string
      const array = new Uint8Array(length);
      if (window.crypto && window.crypto.getRandomValues) {
        window.crypto.getRandomValues(array);
      } else {
        // fallback (not crypto secure, but rarely hit)
        for (let i = 0; i < length; i++) {
          array[i] = Math.floor(Math.random() * 256);
        }
      }
      return Array.from(array, (b) => b.toString(16).padStart(2, "0")).join("");
    },

    setCookie(name, value, days) {
      const d = new Date();
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = "expires=" + d.toUTCString();
      document.cookie =
        name + "=" + encodeURIComponent(value) + ";" + expires + ";path=/";
    },

    getCookie(name) {
      const match = document.cookie.match(
        new RegExp("(^| )" + name + "=([^;]+)")
      );
      return match ? decodeURIComponent(match[2]) : null;
    },

    initUserId() {
      const cookieName = "tilesSurveyUid";
      let uid = this.getCookie(cookieName);
      if (!uid) {
        uid = this.secureRandomString(16);
        this.setCookie(cookieName, uid, 365); // 1 year
      }
      this.userId = uid;
      console.log("User ID (from cookie):", this.userId);
    },

    // --- SAVE EXERCISE ---
    saveExercise(notify) {
      let ref;
      let vm = this;

      if (!this.exercise || !this.exercise.id) {
        // new document
        ref = fb[this.$route.meta.model].doc();
      } else {
        // update existing
        ref = fb[this.$route.meta.model].doc(this.exercise.id);
      }

      ref
        // answers are flattened onto the doc as well (keeps the results views working)
        .set(
          Object.assign({}, this.detailsPayload, {
            updatedOn: new Date(),
            id: ref.id,
            uid: this.userId,
            pid:
              this.currentProjectModel && this.currentProjectModel.id
                ? this.currentProjectModel.id
                : "unknown",
            selectedTiles: this.shortlist,
            cols: this.cols, // existing step-2/3 grid cols

            // details
            details: this.detailsPayload,
            step: this.e1,

            // 🔹 Tiles arranger config
            gridSlots: this.gridSlots || [],
            gridCols: this.gridCols || 4,
            cellSize: this.gridCellSize || 120,
          })
        )
        .then(() => {
          this.exercise.id = ref.id;
          if (notify) {
            vm.dialog = true;
          }
        })
        .catch((error) => {
          alert("Error adding document: " + error);
        });
    },

    changeFilter(val) {
      this.filters = val;
    },
  },
};
</script>


<style lang="scss">
.canvas {
  position: relative;
  width: 100%;
  height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: grey;

  &__tile {
    width: 200px;
    height: 200px;
    background-size: cover;
    background-position: center;
    margin: 2px;
  }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
